export default {
  name: 'Gallery section - 5',
  tab: 'gallery',
  type: 'media-gallery-default-section',
  content: {
    title: '',
    introtext: '',
    images:
      '[{"item-title":"","item-image":"/storage/media/samples/lucas-davies-UfmAKd2GKHY-unsplash.jpg","button-text":"","button-link":"#","button-style":"outlined","button-background-color":"var(--text-light-color)","button-text-color":"var(--text-light-color)"},{"item-title":"","item-image":"/storage/media/samples/ian-dooley-TevqnfbI0Zc-unsplash.jpg","button-text":"","button-link":"#","button-style":"outlined","button-background-color":"var(--text-light-color)","button-text-color":"var(--text-light-color)"},{"item-title":"","item-image":"/storage/media/samples/derek-thomson-NqJYQ3m_rVA-unsplash.jpg","button-text":"","button-link":"#","button-style":"outlined","button-background-color":"var(--text-light-color)","button-text-color":"var(--text-light-color)"}]'
  },
  design: {
    'background-color': 'var(--background-color)',
    'background-image': '',
    'background-image-tablet': '',
    'background-image-mobile': '',
    'parallax-background-image': '0',
    'custom-padding': '1',
    'padding-top': '99px',
    'padding-bottom': '100px',
    'title-color': 'inherit',
    'title-font-weight': 'var(--title-font-weight)',
    'title-tag': 'h4',
    'introtext-color': 'inherit',
    'item-title-color': 'var(--text-light-color)',
    'item-title-font-weight': 'lighter',
    'item-title-tag': 'h6'
  },
  layout: {
    'content-container-fluid': '1',
    'content-container-size': 'xl',
    'content-horizontal-alignment': 'start',
    'content-no-gutters': '1',
    'item-columns': '3',
    'inner-content-horizontal-alignment': 'start',
    'inner-content-padding': '12px',
    'item-size': 'aspect-ratio',
    'item-aspect-ratio': '1.33',
    'content-box': '0',
    'content-box-wrap': 'item',
    'content-box-color': 'black',
    'content-box-padding': '30px',
    'content-box-opacity': '0.5',
    'content-box-elevation': '0',
    'content-box-border': '0',
    'content-box-border-color': 'var(--text-dark-color)',
    'content-box-rounded': '0'
  },
  advanced: {}
}
